import { useState } from "react";
import Grid from "@mui/material/Grid";
import ServicesCard from "../components/ServicesCard";
import vastu from "../assets/vastu.jpg";
import numerology from "../assets/numerology.avif";
import CreatePropertyDialog from "../components/property/CreatePropertyForm";
import { Box } from "@mui/material";

export default function ServicesPage() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  // const handleFormSubmit = (data: any) => {
  //   console.log("Form Data:", data);
  //   setIsDialogOpen(false);
  // };

  // Example services data
  const services = [
    {
      image: vastu,
      title: "Modern Vastu",
      description: "Description of Service One. Lorem ipsum dolor sit amet.",
      buttonText: "Get Started",
    },
    {
      image: numerology,
      title: "Numerology",
      description:
        "Description of Service Two. Aenean commodo ligula eget dolor.",
      buttonText: "Try Now",
    },
    {
      image: numerology,
      title: "Numerology",
      description:
        "Description of Service Two. Aenean commodo ligula eget dolor.",
      buttonText: "Try Now",
    },
    {
      image: vastu,
      title: "Modern Vastu",
      description: "Description of Service One. Lorem ipsum dolor sit amet.",
      buttonText: "Get Started",
    },
    {
      image: numerology,
      title: "Numerology",
      description:
        "Description of Service Two. Aenean commodo ligula eget dolor.",
      buttonText: "Try Now",
    },
    {
      image: vastu,
      title: "Modern Vastu",
      description: "Description of Service One. Lorem ipsum dolor sit amet.",
      buttonText: "Get Started",
    },
    {
      image: numerology,
      title: "Numerology",
      description:
        "Description of Service Two. Aenean commodo ligula eget dolor.",
      buttonText: "Try Now",
    },
    {
      image: vastu,
      title: "Modern Vastu",
      description: "Description of Service One. Lorem ipsum dolor sit amet.",
      buttonText: "Get Started",
    },
  ];

  return (
    <Box sx={{ py: 8 }}>
      {/* Content here */}


      {/* <Typography variant="h4" align="center" gutterBottom sx={{ color: '#rgba(207, 207, 207, 0.38)', fontFamily: 'sans-serif' }}>
        Our Services
      </Typography> */}


      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item key={index} xs={12} sm={12} md={4}>
            <ServicesCard
              image={service.image}
              title={service.title}
              description={service.description}
              buttonText={service.buttonText}
              onClick={handleOpenDialog} // Open the dialog when clicking the service card
            />
          </Grid>
        ))}
      </Grid>

      {/* CreatePropertyDialog will open when a service is clicked */}
      <CreatePropertyDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        // onSubmit={handleFormSubmit}
      />
    </Box>
  );
}
